import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

export const OptionsButtons = ({ options, onSelectOption, showBar }) => {
  const { t } = useTranslation();

  const optionLabelByType = {
    approve: t('chatsocket.buttons.approve'),
    edit: t('chatsocket.buttons.edit'),
    reject: t('chatsocket.buttons.reject'),
    MOCK_SELECT_PLAN: t('chatsocket.buttons.select_plan'),
    MOCK_NEW_CAMPAIGN: t('chatsocket.buttons.new_campaign'),
    MOCK_REGERAR_AGORA: t('chatsocket.buttons.regenerate_from_scratch'),
    mock_retry_campaign: t('chatsocket.buttons.restart_campaign'),
    MOCK_CONFIRM_BATCH_EDIT_ART: t('chatsocket.buttons.confirm'),
    MOCK_CANCEL_BATCH_EDIT_ART: t('chatsocket.buttons.cancel'),
  };

  const getOptionLabel = (option) => option?.name || optionLabelByType[option?.type] || '';

  const getButtonClassName = (option) => {
    const baseClass = styles.optionButton;
    const disabledClass = option.disabled ? ` ${styles.optionButtonDisabled}` : '';
    const optionLabel = getOptionLabel(option);

    if (option.type === 'approve') {
      return `${baseClass} ${styles.optionButtonApprove}${disabledClass}`;
    } else if (option.type === 'edit') {
      return `${baseClass} ${styles.optionButtonEdit}${disabledClass}`;
    } else if (option.type === 'reject') {
      return `${baseClass} ${styles.optionButtonReject}${disabledClass}`;
    }

    // Campaign completion buttons
    const primaryCampaignButtons = [
      t('chatsocket.buttons.select_plan'),
      t('chatsocket.buttons.new_campaign'),
    ];
    if (
      option.type === 'MOCK_SELECT_PLAN' ||
      option.type === 'MOCK_NEW_CAMPAIGN' ||
      primaryCampaignButtons.includes(optionLabel)
    ) {
      return `${baseClass} ${styles.optionButtonPrimary}${disabledClass}`;
    }

    if (
      optionLabel === t('chatsocket.buttons.finalize') ||
      optionLabel === t('chatsocket.buttons.finalize_campaign')
    ) {
      return `${baseClass} ${styles.optionButtonSecondary}${disabledClass}`;
    }

    return `${baseClass}${disabledClass}`;
  };

  return (
    <div className={showBar ? styles.optionsButtonsContainerEdit : styles.optionsButtonsContainer}>
      {options.map((option, index) => {
        const optionLabel = getOptionLabel(option);
        const buttonTitle = option.disabled
          ? option.disabledReason || option.disabledTitle || optionLabel
          : option.title || optionLabel;

        return (
          <button
            key={index}
            type="button"
            className={getButtonClassName(option)}
            onClick={() => {
              if (option.disabled) {
                return;
              }

              onSelectOption(optionLabel, option.type);
            }}
            disabled={!!option.disabled}
            title={buttonTitle}
          >
            {optionLabel}
          </button>
        );
      })}
    </div>
  );
};
